import { FarmhandMcw } from './farmhand-mcw';
import { MultilineQuote } from './multiline-quote';
import { HomeTabActions } from './home-tab-actions';
import { TabPager } from './tab-pager';
import { StartQuoteController } from './start-quote';
import { Truncate } from './truncate';
import { BlogCarousel } from './blog-carousel';
import { PopupManager } from './popup';
import { AdFeatureCarousel } from './ad-feature-carousel';
import { RentersQuiz } from './renters-quiz';
import { DatePickerController } from './date-picker';
import { RandomizeImages } from './randomize-images';
import { HomeownersQuiz } from './homeowners-quiz';
import { ClaimsSatisfaction } from './claims-satisfaction-survey';
import { FinancialInstitutionInquiry } from './financial-institution-inquiry';
import { ReachAgent } from './reach-an-agent';
import { DriveTrend } from './drivetrend';
import { LinearProgressIndicator } from './linear-progress-indicator';
import { LifeCalculator } from './life-calculator';
import { FindAgentOfficeMap } from './find-agent-office-map';
import { ApProfileCard } from './ap-profile-card';
import { onReady } from './utils/on-ready';
import * as jQuery from 'jquery';

declare var window: any;

// jQuery
window.$ = window.jQuery = jQuery;
import 'script-loader!../../../node_modules/jquery/dist/jquery.min.js';

// using script loader for legacy scripts that need to be in global scope
import 'script-loader!./details-shim.js';
import 'script-loader!./lazysizes.js';
import 'script-loader!./tooltip.js';
import 'script-loader!./confetti.js';
import 'script-loader!./geocode.js';
import 'script-loader!./form-input-handling.js';
import 'script-loader!./knockout-validation.min.js';
import 'script-loader!./find-agent.js';
import 'script-loader!./analytics-tracking.js';
import 'script-loader!./MVC_Widget_Helpers.js';
import 'script-loader!./array.prototype.includes.js';
import 'script-loader!./agent-search-result-toggle.js';
import 'script-loader!./faq.js';

// IE polyfills
import 'whatwg-fetch';
import 'es6-promise/auto';
import 'polyfill-array-includes';
import { bindComponentsToClass } from './utils/bind-components-to-class';
import { LocalAgentFinder } from './local-agent-finder';
import { TabPane } from './tab-pane';
import { MegaTab } from './mega-tab';
import { ContactAgencyPrincipal } from './contact-agency-principal';
import { MyAgentOverlay } from './my-agent-overlay';
import { AgencyPrincipalNavigation } from './agency-principal-navigation';
import { CountyReacoutOfficeMap } from './county-reachout-office-map';

// Custom code - modularized
window.farmhandMcw = new FarmhandMcw();
window.hta = new HomeTabActions();
window.TabPager = new TabPager();
window.startQuoteController = new StartQuoteController();
window.blogCarousel = new BlogCarousel();
window.truncate = new Truncate();
window.adFeatureCarousel = new AdFeatureCarousel();
window.rentersQuiz = new RentersQuiz();
window.datePicker = new DatePickerController();
window.randomizeImageds = new RandomizeImages();
window.homeownersQuiz = new HomeownersQuiz();
window.linearProgressIndicator = new LinearProgressIndicator();
window.apProfileCard = new ApProfileCard();

onReady(() => {
    window.popupManager = new PopupManager();

    const claimSurveyElement = document.getElementById(ClaimsSatisfaction.htmlId);
    const financialInquiryElement = document.getElementById(FinancialInstitutionInquiry.htmlId);
    const reachAgentElement = document.getElementById(ReachAgent.htmlId);
    const drivetrendElement = document.getElementById(DriveTrend.htmlId);
    const lifeCalculatorElement = document.getElementById(LifeCalculator.htmlId);
    const findAgentOfficeMapElement = document.getElementById(FindAgentOfficeMap.htmlId);
    const countyReachoutOfficeMapElement = document.getElementById(CountyReacoutOfficeMap.htmlId);

    if (claimSurveyElement)
        window.claimsSurvey = new ClaimsSatisfaction(claimSurveyElement);

    if (financialInquiryElement)
        window.financialSurvey = new FinancialInstitutionInquiry(financialInquiryElement);
    if (reachAgentElement)
        window.reachAgent = new ReachAgent(reachAgentElement);

    if (drivetrendElement)
        window.drivetrend = new DriveTrend(drivetrendElement);

    if (lifeCalculatorElement)
        window.lifeCalculator = new LifeCalculator();

    if (findAgentOfficeMapElement)
        window.findAgentOfficeMap = new FindAgentOfficeMap();

    if (countyReachoutOfficeMapElement)
        window.countyReacoutOfficeMap = new CountyReacoutOfficeMap();

    window.mlq = new MultilineQuote();
    window.localAgentFinders = bindComponentsToClass(LocalAgentFinder.cssClass, el => new LocalAgentFinder(el as HTMLButtonElement));
    window.tabPanes = bindComponentsToClass(TabPane.cssClass, el => new TabPane(el));
    window.megaTabs = bindComponentsToClass(MegaTab.cssClass, el => new MegaTab(el));
    window.apContacts = bindComponentsToClass(ContactAgencyPrincipal.cssClass, el => new ContactAgencyPrincipal(el as HTMLFormElement));
    window.agentOverlays = bindComponentsToClass(MyAgentOverlay.cssClass, el => new MyAgentOverlay(el as HTMLDivElement));
    window.apNav = bindComponentsToClass(AgencyPrincipalNavigation.cssClass, el => new AgencyPrincipalNavigation(el as HTMLDivElement));
});